import { Component, Input, NgZone, ElementRef } from '@angular/core';
import {Http, Headers, Response} from '@angular/http';
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/map'
//import { HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { httpService } from '../service/servicio'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';

@Component({
  selector: 'app-posiciones',
  templateUrl: './posiciones.component.html',
  styleUrls: ['./posiciones.component.css']
})
export class PosicionesComponent  {

  constructor (private http: httpService,  public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

      this.toastr.setRootViewContainerRef(vcr);
      this.descargarPosiciones();
      this.orden(2);

    };


    uploaded = {
      Status:0,
      Text:''

    }

    @Input() posiciones:any = [];
    @Input() clientes: any = [];


    posicionSearch: string ='';
    place:string = 'Buscar por Cliente';
    sort: string = 'Nombre';

    orden(n) {
      if (n == 1) { this.sort='Id'; this.place='Buscar por Id' };
      if (n == 2) { this.sort='Nombre'; this.place='Buscar por Cliente' };
      if (n == 3) { this.sort='Descripcion'; this.place='Buscar por Posicion' };
      if (n == 4) { this.sort='Direccion'; this.place='Buscar por Direccion' };
      if (n == 5) { this.sort='Poblacion'; this.place='Buscar por Poblacion' };

    }

   quitarfiltro(tipo: Number) {
      this.posicionSearch = '';
   }

  filtro() {
      return this.posiciones.filter((posicion) => {
         if (this.sort == 'Nombre') {
            if (posicion.Nombre == null) posicion.Nombre ="Sin Asignar";
            return posicion.Nombre.toLowerCase().indexOf(this.posicionSearch.toLowerCase()) != -1;
        }
         if (this.sort == 'Descripcion')
            return posicion.Descripcion.toLowerCase().indexOf(this.posicionSearch.toLowerCase()) != -1;
         if (this.sort == 'Id')
           return posicion.Id.toLowerCase().indexOf(this.posicionSearch.toLowerCase()) != -1;
        if (this.sort == 'Direccion')
           return posicion.Direccion.toLowerCase().indexOf(this.posicionSearch.toLowerCase()) != -1;
        if (this.sort == 'Poblacion')
           return posicion.Poblacion.toLowerCase().indexOf(this.posicionSearch.toLowerCase()) != -1;

       });
  }


  descargarPosiciones() {
    this.http.descargarconsultaPosiciones()
        .subscribe(posicion => {
                   this.posiciones = posicion;

              }, err => {

              }, () => {

              });
  }



  pulsado(posicion) {
      this.http.posicionGrabar = posicion;
      this.http.posicionGrabar.Observaciones = this.http.miReplace(this.http.posicionGrabar.Observaciones, "$", "\r");

      this.http.sw.mostrarPosiciones = false;
      this.http.sw.mostrarMenu = false;
      this.http.sw.mostrarDatosposiciones = true;
  }


  crearPosicion() {
       
     this.http.posicionGrabar = this.http.nuevaPosicion();
     this.http.sw.mostrarDatosposiciones = true;
  }



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/posiciones/posiciones.component.ts